import { useContext } from "react";
import { ProductContext } from "../../../../context/product-context/productContext";
import { UnfinishedApplicationsContext } from "../index";
export const useCustomizedCardUploadStep = (): boolean => {
  const { selectedProduct } = useContext(ProductContext);
  const { unfinishedApplicationsDocument } = useContext(
    UnfinishedApplicationsContext,
  );
  const hasCustomizedCardFeature =
    selectedProduct && selectedProduct?.hasFeature("PICTURE_OR_LOGO_ON_CARD");
  const customizedCard =
    unfinishedApplicationsDocument?.basicAccountApplication?.customizedCard;

  return (
    hasCustomizedCardFeature && customizedCard && customizedCard !== "NONE"
  );
};
